import {
  type ComputedRef,
  type DeepReadonly,
  type Ref, computed,
  readonly,
  ref,
} from 'vue';
import { useStore } from 'vuex';

import type { AccountQRCodeDTO } from '@common/contracts/server/account';

import { apiManager } from '@/api/api-manager/api-manager';
import { logger } from '@/plugins/logger';

const fetchQrCode = async (): Promise<string | undefined> => {
  try {
    const response: AccountQRCodeDTO = await apiManager.$apiBFF.fetchQrCode();

    return response.qrCode;
  } catch (err) {
    logger.error(err);
  }
};

const isModalShown = ref<boolean>(false);
export function useClubModal(): {
  isClubModalShown: DeepReadonly<Ref<boolean>>
  bonusesAmount: ComputedRef<number>,
  expiringAmount: ComputedRef<number>,
  expireAt: ComputedRef<string | undefined>,
  userBonusCardNumber: ComputedRef<string>,
  userIsEmployee: ComputedRef<boolean>,
  openModal: () => void,
  closeModal: () => void,
  fetchQrCode: () => Promise<string | undefined>
} {
  const store = useStore();

  const account = computed(() => store.getters['user/account']);
  const userBonusCardNumber = computed(() => store.getters['user/userBonusCardNumber']);
  const bonusesAmount = computed(() => account.value?.bonus?.amount ?? 0);
  const expiringAmount = computed(() => account.value?.bonus?.expiringAmount ?? 0);
  const expireAt = computed(() => account.value?.bonus?.expireAt);
  const closeModal = () => { isModalShown.value = false; };
  const openModal = () => { isModalShown.value = true; };
  const userIsEmployee = computed(() => account.value.personType === 'employee');

  return {
    userBonusCardNumber,
    isClubModalShown: readonly(isModalShown),
    bonusesAmount,
    expiringAmount,
    expireAt,
    userIsEmployee,
    openModal,
    closeModal,
    fetchQrCode,
  };
}
